import React, { PureComponent } from 'react';
import CheckboxTree from 'react-checkbox-tree'; // , { Node as CheckboxTreeNode }
import head from 'lodash/head';

import CheckBoxCheckIcon from '@geobank/assets/src/icons/CheckBoxCheckIcon';
import MinusIcon from '@geobank/assets/src/icons/MinusIcon';
import ExpandIcon from '@geobank/assets/src/icons/ExpandIcon';
import findFirstInObject from './functions/findFirstInObject';

import './CheckBoxTree.css';

export interface CheckboxTreeNode {
  checked: boolean;
  // children: undefined;
  isChild: boolean;
  isLeaf: boolean;
  isParent: boolean;
  value: string;
  // ...
}

interface CheckBoxTreeProps {
  nodes: CheckBoxTreeInterface[];
  onChange?: (
    checkedCheckboxTreeObject: any,
    checked: string[],
    targetNode: CheckboxTreeNode
  ) => void;

  checked?: string[];
}

export interface ICheckedCheckboxTreeObject {
  type: string;
  parent: CheckBoxTreeInterface;
  label: JSX.Element;
  value: string;
  children?: CheckBoxTreeInterface[];
}

interface CheckBoxTreeState {
  checked: string[];
  expanded: any[];
}

export interface CheckBoxTreeInterface {
  label: JSX.Element;
  value: string;
  type: string;
  children?: CheckBoxTreeInterface[];
  className?: string;
  disabled?: boolean;
  icon?: JSX.Element;
  showCheckbox?: boolean;
  title?: string;
}

export default class CheckBoxTree extends PureComponent<CheckBoxTreeProps, CheckBoxTreeState> {
  public state = {
    checked: [],
    expanded: [],
  };

  public componentDidMount() {
    const { checked } = this.props;
    if (checked !== undefined) {
      this.setState({ checked });
    }
  }

  public componentDidUpdate() {
    const { checked } = this.props;
    if (checked !== undefined) {
      this.setState({ checked });
    }
  }

  // private readonly onChangeBoxTreeHandler = () => {
  private readonly onChangeBoxTreeHandler = (checked: string[], targetNode: CheckboxTreeNode) => {
    const { nodes, onChange } = this.props;
    // const { checked } = this.state;
    this.setState({ checked });

    const checkedItems = checked.map(checkedItem =>
      head(
        nodes
          .map(item => {
            return findFirstInObject(item, 'children', { value: checkedItem });
          })
          .filter(item => item !== false)
      )
    );
    if (onChange) {
      /* пока возвращает checkedItems в виде any*/
      onChange(checkedItems, checked, targetNode);
    }
  };

  public render() {
    const { nodes } = this.props;
    return (
      <CheckboxTree
        nodes={nodes}
        icons={{
          check: (
            <div>
              <CheckBoxCheckIcon fill={'#6AC3FA'} />
            </div>
          ),
          uncheck: <div />,
          halfCheck: (
            <div>
              <MinusIcon fill={'#6AC3FA'} />
            </div>
          ),
          expandClose: (
            <div style={{ transition: '0.6s', transform: 'rotate(0deg)' }}>
              <ExpandIcon fill={'#6AC3FA'} />
            </div>
          ),
          expandOpen: (
            <div style={{ transition: '0.6s', transform: 'rotate(180deg)' }}>
              <ExpandIcon fill={'#6AC3FA'} />
            </div>
          ),
          // expandAll: <FontAwesomeIcon className="rct-icon rct-icon-expand-all" icon="plus-square" />,
          // collapseAll: <FontAwesomeIcon className="rct-icon rct-icon-collapse-all" icon="minus-square" />,
          // parentClose: <FontAwesomeIcon className="rct-icon rct-icon-parent-close" icon="folder" />,
          // parentOpen: <FontAwesomeIcon className="rct-icon rct-icon-parent-open" icon="folder-open" />,
          // leaf: <FontAwesomeIcon className="rct-icon rct-icon-leaf-close" icon="file" />
        }}
        checked={this.state.checked}
        expanded={this.state.expanded}
        // onCheck={checked => this.setState({ checked }, this.onChangeBoxTreeHandler)}
        // @ts-ignore
        onCheck={(checked, targetNode) => this.onChangeBoxTreeHandler(checked, targetNode)}
        onExpand={expanded => this.setState({ expanded })}
        nativeCheckboxes={false}
      />
    );
  }
}
